/*global jQuery */
;(function ($, window, document, undefined) {
  'use strict';
  var $document,
      $toggleButton,
      $docElement,
      eventAction = 'menu/update',
      dataSelector = 'data-menu',
      openState = 'mainmenuOpen',
      closeState = 'mainmenuClose',

      init = function () {

        $document = $(document);
        $docElement = $(document.documentElement);
        $toggleButton = $('.js-mainmenu-toggle');

        // listen on menu change
        $document.on(eventAction, function(){
          var menuData = $docElement.attr(dataSelector);

          // change aria labels
          if(menuData === openState) {
            $toggleButton.attr('aria-expanded', 'false');
          } else {
            $toggleButton.attr('aria-expanded', 'true');
          }
        });

        // toggle click handler
        $document.on('click', '.js-mainmenu-toggle', function (e) {

          e.preventDefault();

          var menuData = $docElement.attr(dataSelector);

          if (menuData === openState) {
            $docElement.attr(dataSelector,closeState);
            $document.triggerHandler(eventAction);
          } else {
            $docElement.attr(dataSelector,openState);
            $document.triggerHandler(eventAction);
          }
        });
      };
  init();


})(jQuery, window, document);
